export default __webpack_public_path__ + "static/media/stats.7ce145d4.gif";